export default {
    getMenuState: state => {
        return state.isMenuActive
    },
    getActiveTrackingAsideTab: state => {
        return state.activeTrackingAsideTab
    }
}
